import { Pipe, PipeTransform } from '@angular/core'
import _ from 'lodash'
import { DisplayNamePipe } from './display-name.pipe'

@Pipe({ name: 'displayMultipleNames' })
export class DisplayMultipleNamesPipe extends DisplayNamePipe implements PipeTransform {
    transform(subjects: Array<any>): string {
        if (subjects[0].orderName === undefined) {
            subjects = subjects.map(obj => ({ ...obj, orderName: obj.prijmeni + obj.jmeno + obj.nazev }))
            subjects = subjects.sort((a, b) => a.orderName.localeCompare(b.orderName))
        }
        return _.join(_.map(subjects,
                subject => super.transform(subject)), ', ')
    }
}